
const VIEW_MAKE = 'VIEW_MAKE';
const MODIFY_MAKE = 'MODIFY_MAKE';
const DELETE_MAKE = 'DELETE_MAKE';

const VIEW_CONTACT = 'VIEW_CONTACT';
const MODIFY_CONTACT = 'MODIFY_CONTACT';
const DELETE_CONTACT = 'DELETE_CONTACT';

const VIEW_LEAD = 'VIEW_LEAD';
const MODIFY_LEAD = 'MODIFY_LEAD';
const DELETE_LEAD = 'DELETE_LEAD';

const VIEW_SITE_VISIT = 'VIEW_SITE_VISIT';
const MODIFY_SITE_VISIT = 'MODIFY_SITE_VISIT';
const DELETE_SITE_VISIT = 'DELETE_SITE_VISIT';

const VIEW_OFFER = 'VIEW_OFFER';
const MODIFY_OFFER = 'MODIFY_OFFER';
const DELETE_OFFER = 'DELETE_OFFER';

const VIEW_ORDER = 'VIEW_ORDER';
const MODIFY_ORDER = 'MODIFY_ORDER';
const DELETE_ORDER = 'DELETE_ORDER';

const VIEW_WARRANTY = 'VIEW_WARRANTY';
const MODIFY_WARRANTY = 'MODIFY_WARRANTY';
const DELETE_WARRANTY = 'DELETE_WARRANTY';

const VIEW_AMC = 'VIEW_AMC';
const MODIFY_AMC = 'MODIFY_AMC';
const DELETE_AMC = 'DELETE_AMC';

const VIEW_PRODUCT = 'VIEW_PRODUCT';
const MODIFY_PRODUCT = 'MODIFY_PRODUCT';
const DELETE_PRODUCT = 'DELETE_PRODUCT';

const VIEW_FILE = 'VIEW_FILE';
const MODIFY_FILE = 'MODIFY_FILE';
const DELETE_FILE = 'DELETE_FILE';

const VIEW_TASK = 'VIEW_TASK';
const MODIFY_TASK = 'MODIFY_TASK';
const DELETE_TASK = 'DELETE_TASK';

const VIEW_PAYMENT = 'VIEW_PAYMENT';
const MODIFY_PAYMENT = 'MODIFY_PAYMENT';
const DELETE_PAYMENT = 'DELETE_PAYMENT';

const MODIFY_ALL = 'MODIFY_ALL';
const VIEW_ALL = 'VIEW_ALL';
const DELETE_ALL = 'DELETE_ALL';

const LIST_ATTENDANCE = 'LIST_ATTENDANCE';
const VIEW_ATTENDANCE = 'VIEW_ATTENDANCE';

const VIEW_USER = 'VIEW_USER';
const MODIFY_USER = 'MODIFY_USER';
const DELETE_USER = 'DELETE_USER';

const VIEW_QUOTATION = 'VIEW_QUOTATION';
const MODIFY_QUOTATION = 'MODIFY_QUOTATION';
const DELETE_QUOTATION = 'DELETE_QUOTATION';

const VIEW_ROLE = 'VIEW_ROLE';
const MODIFY_ROLE = 'MODIFY_ROLE';
const DELETE_ROLE = 'DELETE_ROLE';

const VIEW_PERMISSION = 'VIEW_PERMISSION';
const MODIFY_PERMISSION = 'MODIFY_PERMISSION';
const DELETE_PERMISSION = 'DELETE_PERMISSION';

const VIEW_ROLE_PERMISSION = 'VIEW_ROLE_PERMISSION';
const MODIFY_ROLE_PERMISSION = 'MODIFY_ROLE_PERMISSION';
const DELETE_ROLE_PERMISSION = 'DELETE_ROLE_PERMISSION';

const VIEW_DASHBOARD = 'VIEW_DASHBOARD';
const VIEW_REPORT = 'VIEW_REPORT';
const VIEW_BACKUP = 'VIEW_BACKUP';

const PERMISSIONS = {
    VIEW_MAKE, MODIFY_MAKE, DELETE_MAKE,
    VIEW_CONTACT, MODIFY_CONTACT, DELETE_CONTACT,
    VIEW_LEAD, MODIFY_LEAD, DELETE_LEAD,
    VIEW_SITE_VISIT, MODIFY_SITE_VISIT, DELETE_SITE_VISIT,
    VIEW_OFFER, MODIFY_OFFER, DELETE_OFFER,
    VIEW_ORDER, MODIFY_ORDER, DELETE_ORDER,
    VIEW_WARRANTY, MODIFY_WARRANTY, DELETE_WARRANTY,
    VIEW_AMC, MODIFY_AMC, DELETE_AMC,
    VIEW_PRODUCT, MODIFY_PRODUCT, DELETE_PRODUCT,
    VIEW_FILE, MODIFY_FILE, DELETE_FILE,
    VIEW_TASK, MODIFY_TASK, DELETE_TASK,
    VIEW_PAYMENT, MODIFY_PAYMENT, DELETE_PAYMENT,
    VIEW_ATTENDANCE, LIST_ATTENDANCE,
    VIEW_ALL, MODIFY_ALL, DELETE_ALL,
    VIEW_USER, MODIFY_USER, DELETE_USER,
    VIEW_QUOTATION, MODIFY_QUOTATION, DELETE_QUOTATION,
    VIEW_ROLE, MODIFY_ROLE, DELETE_ROLE,
    VIEW_PERMISSION, MODIFY_PERMISSION, DELETE_PERMISSION,
    VIEW_ROLE_PERMISSION, MODIFY_ROLE_PERMISSION, DELETE_ROLE_PERMISSION,
    VIEW_REPORT, VIEW_BACKUP,
    VIEW_DASHBOARD,
};

export default PERMISSIONS;